import { Box } from "@mui/material";
import { keyframes, styled } from "@mui/material/styles";
import React from "react";

import wave from "@/assets/wave.png";

interface LoaderGenericProps {
  cardSize: number;
}

const fillingDropAnimation = keyframes({
  "50%": {
    backgroundPosition:
      "var(--animation-loader_generic-wave-x-osition-start) var(--animation-loader_generic-wave-y-position-start)",
  },
  "100%": {
    backgroundPosition:
      "var(--animation-loader_generic-wave-x-position-end) var(--animation-loader_generic-wave-y-position-end)",
  },
});

const DropletContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== "cardSize",
})<LoaderGenericProps>(({ cardSize }) => ({
  "--animation-loader_generic-wave-x-position-start": `${cardSize / 2}px`,
  "--animation-loader_generic-wave-x-position-end": `${cardSize * 3}px`,
  "--animation-loader_generic-wave-y-position-start": "0px",
  "--animation-loader_generic-wave-y-position-end": `${cardSize / 4}px`,

  position: "relative",
  width: `${cardSize / 4}px`,
  height: `${cardSize / 4}px`,
  borderRadius: "0 50% 50% 50%",
  transform: "rotate(45deg)",
  overflow: "hidden",
  border: `${cardSize * 0.01}px solid white`,
}));

const WaterAnimation = styled(Box, {
  shouldForwardProp: (prop) => prop !== "cardSize",
})<LoaderGenericProps>(({ cardSize }) => ({
  position: "absolute",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  backgroundImage: `url(${wave})`,
  backgroundSize: `${cardSize / 2}px`,
  backgroundPosition: `0px ${cardSize / 4}px`,
  backgroundRepeat: "repeat-x",
  animation: `${fillingDropAnimation} 10s ease-in-out infinite`,
  transform: "rotate(-45deg)",
}));
export const LoaderGeneric: React.FC<LoaderGenericProps> = ({ cardSize }) => {
  return (
    <DropletContainer cardSize={cardSize}>
      <WaterAnimation cardSize={cardSize} />
    </DropletContainer>
  );
};
